"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexToPos = exports.posToIndex = exports.neighborPositionsChunked = exports.neighborPositions = exports.neighborIndices = exports.neighbors = void 0;
const Vector2_1 = require("./Vector2");
function neighbors(array, position, size) {
    return neighborIndices(position, size)
        .map(index => array[index]);
}
exports.neighbors = neighbors;
function neighborIndices(position, size) {
    return neighborPositions(position, size)
        .map(entry => posToIndex(entry, size));
}
exports.neighborIndices = neighborIndices;
function neighborPositions(position, size) {
    return [
        new Vector2_1.Vector2(-1, -1), new Vector2_1.Vector2(0, -1), new Vector2_1.Vector2(1, -1),
        new Vector2_1.Vector2(-1, 0), new Vector2_1.Vector2(1, 0),
        new Vector2_1.Vector2(-1, 1), new Vector2_1.Vector2(0, 1), new Vector2_1.Vector2(1, 1)
    ]
        .map(relative => position.add(relative))
        .filter(entry => onlyInBounds(entry, size));
}
exports.neighborPositions = neighborPositions;
function neighborPositionsChunked(chunkedPosition) {
    return [
        new Vector2_1.Vector2(-1, -1), new Vector2_1.Vector2(0, -1), new Vector2_1.Vector2(1, -1),
        new Vector2_1.Vector2(-1, 0), new Vector2_1.Vector2(1, 0),
        new Vector2_1.Vector2(-1, 1), new Vector2_1.Vector2(0, 1), new Vector2_1.Vector2(1, 1)
    ]
        .map(relative => chunkedPosition.add(relative));
}
exports.neighborPositionsChunked = neighborPositionsChunked;
function posToIndex(position, size) {
    return position.x + position.y * size.x;
}
exports.posToIndex = posToIndex;
function indexToPos(index, size) {
    return new Vector2_1.Vector2(index % size.x, Math.floor(index / size.x));
}
exports.indexToPos = indexToPos;
function onlyInBounds(vector2, size) {
    return vector2.x >= 0 && vector2.y >= 0 &&
        vector2.x < size.x && vector2.y < size.y;
}
//# sourceMappingURL=2dFieldOperations.js.map